module.exports = __webpack_public_path__ + "img/icon2.ddd11cb2.svg";